import React from 'react';
import './Headings.css';

const Headings = ({ title, text }) => {
    return (
        <div className="headings">
            <span className="headings-kicker">SmartSastram</span>
            <h2>{title}</h2>
            <p>{text}</p>
        </div>
    )
}

export default Headings
